<template>
    <standard-modal
        name="cookie-settings-modal"
        action="/"
        :title="translation('cookie_modal_title')"
        :show-close-button="false"
    >
        <div class="leading-tight">
            <!-- eslint-disable vue/no-v-html -->
            <p class="mb-xl" v-html="translation('cookies_modal_pretext')" />
            <div
                v-for="(policy, key) in cookiePolicies"
                class="border-b border-neutral-lighter mt-xl pb-xl"
            >
                <div class="w-full flex">
                    <checkbox-input
                        v-model="policy.hasPermitted"
                        :value="policy.bitmask"
                        :disabled="key === 'necessary'"
                    >
                        <h4 class="leading-normal">
                            {{ policy.label }}
                        </h4>
                    </checkbox-input>
                </div>
                <div class="w-full">
                    {{ policy.description }}
                </div>
            </div>

            <div class="button-group mt-3xl">
                <button
                    type="button"
                    class="btn is-ghost btn-lg"
                    @click="hide"
                >
                    {{ lang('Stäng', 'Close') }}
                </button>
                <button
                    type="button"
                    class="btn btn-lg is-primary"
                    @click="save"
                >
                    {{ lang('Spara', 'Save') }}
                </button>
            </div>
        </div>
    </standard-modal>
</template>
<script>
    export default {
        props: {
            cookiePolicies: {
                type: Object,
                required: true,
            },
            permissions: {
                type: Number,
                required: false,
                default: null,
            },
        },
        data() {
            return {
                localPermissions: this.permissions || (this.cookiePolicies.necessary.bitmask + this.cookiePolicies.fonts.bitmask),
            };
        },
        created() {
            Object.values(this.cookiePolicies).forEach(policy => policy.hasPermitted = this.isPermitted(policy));
        },
        methods: {
            save() {
                this.$emit('save', this.calculatePermissions());
                this.hide();
            },
            hide() {
                this.$modal.hide('cookie-settings-modal');
            },
            calculatePermissions() {
                return Object
                    .values(this.cookiePolicies)
                    .reduce((total, { hasPermitted, bitmask }) => total + (hasPermitted ? bitmask : 0), 0);
            },
            isPermitted(policy) {
                return (policy.bitmask & this.localPermissions) !== 0;
            },
        },
    };
</script>
